'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const winnersHide = document.querySelectorAll('.winners-card--hidden');

  if(winnersHide && window.outerWidth >= 1050) {
    let winnersArrHide = [...winnersHide];
    let interval = setInterval(() => {
      let el = winnersArrHide.pop();
      if(el) {
        slideDown(el, 500, 'flex');
        el.classList.remove('winners-card--hidden');
      } else {
        clearInterval(interval);
      }
    }, 5000);
  }

});